module.exports = __webpack_public_path__ + "static/img/square-minus.ac95cceb.svg";